exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reply-dialog-button mat-icon {\n  color: #fff; }\n\n.mat-card {\n  min-width: 700px; }\n\n.mat-card-title {\n  font-size: 2rem !important; }\n\n.mat-card-header-text {\n  margin: 0 !important; }\n\n.mat-card-actions button {\n  float: right; }\n\n.brand {\n  margin-right: 12px; }\n\n.mat-card-content {\n  padding-left: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/corporate-support/corporate-support.component.scss
// module id = ../../../../../src/app/main/content/corporate-support/corporate-support.component.scss
// module chunks = main